import { c as _c } from "react/compiler-runtime";
import { CodeBrowserIcon } from '@systemeio/icons';
import { FunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/funnel-step-actions';
import { useEmbeddedFormFields } from 'modules/funnels/funnel/hooks/use-embedded-form-fields';
import type { FunnelStepPageActionsProps } from 'modules/funnels/funnel/types/funnel-step-page-actions-props';
import { getRemotePagePreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
import { getEmbeddedFormHtmlCode } from 'modules/funnels/funnel/utils/remote-form-utils';
import { useState } from 'react';
import { Button } from 'shared/components';
import LinkShareModal from 'shared/components/link-share-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
function RemoteFormFunnelStepActions(t0) {
  const $ = _c(34);
  const {
    funnelId,
    funnelStep,
    pageId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isDesktop
  } = useMediaQuery();
  const [embeddedFormOpen, setEmbeddedFormOpen] = useState(false);
  const [shouldFetchEmbeddedForm, setShouldFetchEmbeddedForm] = useState(false);
  const {
    embeddedFormFields
  } = useEmbeddedFormFields(shouldFetchEmbeddedForm, pageId);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.remote.embedded_form");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const embeddedFormLabel = t1;
  const t2 = funnelStep.id;
  let t3;
  if ($[2] !== pageId) {
    t3 = getRemotePagePreviewUrl(pageId);
    $[2] = pageId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setEmbeddedFormOpen(true);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isDesktop ? "sm" : "icon-md";
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CodeBrowserIcon />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = isDesktop ? undefined : "sr-only";
  let t8;
  if ($[6] !== embeddedFormLabel || $[7] !== t7) {
    t8 = <span className={t7}>{embeddedFormLabel}</span>;
    $[6] = embeddedFormLabel;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== embeddedFormLabel || $[10] !== t5 || $[11] !== t8) {
    t9 = <Button aria-label={embeddedFormLabel} onClick={t4} data-test-element="embedded-form-funnel-step-button" title={embeddedFormLabel} variant="secondary" size={t5}>{t6}{t8}</Button>;
    $[9] = embeddedFormLabel;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== funnelId || $[14] !== funnelStep.id || $[15] !== pageId || $[16] !== t3 || $[17] !== t9) {
    t10 = <FunnelStepActions funnelId={funnelId} funnelStepId={t2} pageId={pageId} viewLinkUrl={t3} additionalAction={t9} />;
    $[13] = funnelId;
    $[14] = funnelStep.id;
    $[15] = pageId;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== embeddedFormFields || $[20] !== pageId) {
    t11 = embeddedFormFields ? getEmbeddedFormHtmlCode(embeddedFormFields, pageId) : "";
    $[19] = embeddedFormFields;
    $[20] = pageId;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = !embeddedFormFields;
  let t13;
  if ($[22] !== t) {
    t13 = t("dashboard.funnel.configuration.remote.script_tag");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setEmbeddedFormOpen(false);
    t15 = () => setShouldFetchEmbeddedForm(true);
    $[24] = t14;
    $[25] = t15;
  } else {
    t14 = $[24];
    t15 = $[25];
  }
  let t16;
  if ($[26] !== embeddedFormOpen || $[27] !== t11 || $[28] !== t12 || $[29] !== t13) {
    t16 = <LinkShareModal link={t11} isLoading={t12} label="" title={t13} opened={embeddedFormOpen} onClose={t14} onOpen={t15} showInTextArea={true} />;
    $[26] = embeddedFormOpen;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t10 || $[32] !== t16) {
    t17 = <>{t10}{t16}</>;
    $[31] = t10;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
export { RemoteFormFunnelStepActions };